import { render } from "./Plantations.vue?vue&type=template&id=318c9f0c"
import script from "./Plantations.vue?vue&type=script&lang=js"
export * from "./Plantations.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__